export function Mail() {
  return (
    <svg
      width="16px"
      height="12px"
      viewBox="0 0 16 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Mail</title>
      <g id="Ver2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="UnterbergDuathlon_2"
          transform="translate(-481.000000, -70.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Group-7" transform="translate(471.000000, 54.000000)">
            <g id="envelope" transform="translate(0.000000, 4.000000)">
              <path
                d="M25.696875,15.9625 C25.81875,15.865625 26,15.95625 26,16.109375 L26,22.5 C26,23.328125 25.328125,24 24.5,24 L11.5,24 C10.671875,24 10,23.328125 10,22.5 L10,16.1125 C10,15.95625 10.178125,15.86875 10.303125,15.965625 C11.003125,16.509375 11.93125,17.2 15.11875,19.515625 C15.778125,19.996875 16.890625,21.009375 18,21.003125 C19.115625,21.0125 20.25,19.978125 20.884375,19.515625 C24.071875,17.2 24.996875,16.50625 25.696875,15.9625 Z M18,20 C18.725,20.0125 19.76875,19.0875 20.29375,18.70625 C24.440625,15.696875 24.75625,15.434375 25.7125,14.684375 C25.89375,14.54375 26,14.325 26,14.09375 L26,13.5 C26,12.671875 25.328125,12 24.5,12 L11.5,12 C10.671875,12 10,12.671875 10,13.5 L10,14.09375 C10,14.325 10.10625,14.540625 10.2875,14.684375 C11.24375,15.43125 11.559375,15.696875 15.70625,18.70625 C16.23125,19.0875 17.275,20.0125 18,20 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Phone() {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Phone</title>
      <g id="Ver2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="UnterbergDuathlon_2"
          transform="translate(-929.000000, -67.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Group-7" transform="translate(471.000000, 54.000000)">
            <g id="Group-27" transform="translate(448.000000, 0.000000)">
              <g id="phone-alt" transform="translate(0.000000, 3.000000)">
                <path
                  d="M25.5436303,21.3061916 L22.0435869,19.806173 C21.7364349,19.6752718 21.3797369,19.7631724 21.1685761,20.0218007 L19.6185568,21.9155742 C17.1859459,20.7686217 15.2282532,18.8109289 14.0813007,16.378318 L15.9750741,14.8282988 C16.2342633,14.617493 16.3222646,14.2603861 16.1907018,13.9532879 L14.6906832,10.4532445 C14.5457067,10.120861 14.1849035,9.93849136 13.8312975,10.0188641 L10.5812572,10.7688734 C10.240944,10.8474589 10,11.1505511 10,11.49982 C10,19.5155444 16.4969556,26 24.5001799,26 C24.8495656,26.0002239 25.1528272,25.7591698 25.231439,25.4187426 L25.9814483,22.1687023 C26.0612984,21.8133987 25.8775708,21.4514515 25.5436303,21.3061916 L25.5436303,21.3061916 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Start() {
  return (
    <svg
      width="16px"
      height="20px"
      viewBox="0 0 16 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Start</title>
      <g id="Ver2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="UnterbergDuathlon_2"
          transform="translate(-96.000000, -1453.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Group-14" transform="translate(96.000000, 1249.000000)">
            <g id="Group-12-Copy-2" transform="translate(0.000000, 204.000000)">
              <path
                d="M16,2 L2,2 L2,0 L0,0 L0,20 L2,20 L2,12 L16,12 L14,7 L16,2 Z M12.14,7.74 L13.04,10 L2,10 L2,4 L13.05,4 L12.15,6.26 L11.85,7 L12.14,7.74 Z M9,7 C9,8.1 8.1,9 7,9 C5.9,9 5,8.1 5,7 C5,5.9 5.9,5 7,5 C8.1,5 9,5.9 9,7 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Begin() {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Begin</title>
      <g id="Ver2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="UnterbergDuathlon_2"
          transform="translate(-96.000000, -1652.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Group-14" transform="translate(96.000000, 1249.000000)">
            <g id="Group-12" transform="translate(0.000000, 403.000000)">
              <path
                d="M10.51,7.99 C10.51,6.34 9.16,4.99 7.51,4.99 C5.86,4.99 4.51,6.34 4.51,7.99 C4.51,9.64 5.86,10.99 7.51,10.99 C9.16,10.99 10.51,9.64 10.51,7.99 Z M7.51,8.99 C6.96,8.99 6.51,8.54 6.51,7.99 C6.51,7.44 6.96,6.99 7.51,6.99 C8.06,6.99 8.51,7.44 8.51,7.99 C8.51,8.54 8.06,8.99 7.51,8.99 Z M14.01,10.99 C15.12,10.99 16.01,10.1 16.01,8.99 C16.01,7.88 15.12,6.99 14.01,6.99 C12.9,6.99 12,7.88 12.01,8.99 C12.01,10.1 12.9,10.99 14.01,10.99 Z M10,0 C4.48,0 0,4.48 0,10 C0,15.52 4.48,20 10,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 10,0 Z M3.85,15.11 C4.53,14.57 6.12,14 7.51,14 C7.58,14 7.66,14.01 7.74,14.01 C7.98,13.37 8.41,12.72 9.04,12.15 C8.48,12.05 7.95,11.99 7.51,11.99 C6.21,11.99 4.12,12.44 2.78,13.42 C2.28,12.38 2,11.22 2,9.99 C2,5.58 5.59,1.99 10,1.99 C14.41,1.99 18,5.58 18,9.99 C18,11.19 17.73,12.33 17.25,13.36 C16.25,12.77 14.89,12.49 14.01,12.49 C12.49,12.49 9.51,13.3 9.51,15.19 L9.51,17.97 C7.24,17.84 5.22,16.76 3.85,15.11 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Award() {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Award</title>
      <g id="Ver2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="UnterbergDuathlon_2"
          transform="translate(-1326.000000, -1453.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Group-14" transform="translate(96.000000, 1249.000000)">
            <g
              id="Group-12-Copy"
              transform="translate(1230.000000, 204.000000)"
            >
              <path
                d="M9.99,0 C4.47,0 0,4.48 0,10 C0,15.52 4.47,20 9.99,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 9.99,0 Z M17.47,7.16 L12.46,6.73 L10.46,2.02 C13.67,2.21 16.37,4.29 17.47,7.16 Z M12.4,13.42 L10,11.98 L7.61,13.42 L8.24,10.7 L6.13,8.87 L8.91,8.63 L10,6.06 L11.09,8.62 L13.87,8.86 L11.76,10.69 L12.4,13.42 Z M9.54,2.02 L7.54,6.74 L2.52,7.17 C3.62,4.29 6.32,2.2 9.54,2.02 Z M2,10 C2,9.36 2.08,8.74 2.23,8.14 L6.02,11.42 L4.91,16.17 C3.13,14.7 2,12.48 2,10 Z M5.84,16.82 L10,14.31 L14.16,16.81 C12.94,17.56 11.52,18 9.99,18 C8.47,18 7.05,17.56 5.84,16.82 Z M15.09,16.17 L13.98,11.42 L17.77,8.14 C17.91,8.73 18,9.36 18,10 C18,12.48 16.86,14.7 15.09,16.17 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Calendar() {
  return (
    <svg
      width="22px"
      height="24px"
      viewBox="0 0 22 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Calendar</title>
      <g id="Ver2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="UnterbergDuathlon_2"
          transform="translate(-570.000000, -433.000000)"
          fill="#fff"
          fillRule="nonzero"
        >
          <g id="Group-3" transform="translate(239.482606, 200.650620)">
            <g id="Group-4" transform="translate(330.517394, 221.349380)">
              <path
                d="M19.2,13.4 L18,13.4 L18,11 L15.6,11 L15.6,13.4 L6,13.4 L6,11 L3.6,11 L3.6,13.4 L2.4,13.4 C1.068,13.4 0.012,14.48 0.012,15.8 L0,32.6 C0,33.92 1.068,35 2.4,35 L19.2,35 C20.52,35 21.6,33.92 21.6,32.6 L21.6,15.8 C21.6,14.48 20.52,13.4 19.2,13.4 Z M19.2,32.6 L2.4,32.6 L2.4,20.6 L19.2,20.6 L19.2,32.6 Z M19.2,18.2 L2.4,18.2 L2.4,15.8 L19.2,15.8 L19.2,18.2 Z M10.8,24.2 L16.8,24.2 L16.8,30.2 L10.8,30.2 L10.8,24.2 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Location() {
  return (
    <svg
      width="17px"
      height="24px"
      viewBox="0 0 17 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Location</title>
      <g id="Ver2" stroke="none" strokeWidth="1" fill="#fff" fillRule="evenodd">
        <g
          id="UnterbergDuathlon_2"
          transform="translate(-1027.000000, -2475.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Group-23" transform="translate(0.000000, 2230.000000)">
            <g id="Group-22" transform="translate(96.000000, 128.000000)">
              <g id="Group-20" transform="translate(931.000000, 111.000000)">
                <path
                  d="M8.4,6 C13.044,6 16.8,9.756 16.8,14.4 C16.8,20.7 8.4,30 8.4,30 C8.4,30 0,20.7 0,14.4 C0,9.756 3.756,6 8.4,6 Z M8.4,8.4 C5.088,8.4 2.4,11.088 2.4,14.4 C2.4,17.82 5.904,23.052 8.4,26.256 C10.944,23.028 14.4,17.856 14.4,14.4 C14.4,11.088 11.712,8.4 8.4,8.4 Z M8.4,11.4 C10.0572,11.4 11.4,12.744 11.4,14.4 C11.4,16.056 10.0572,17.4 8.4,17.4 C6.7428,17.4 5.4,16.056 5.4,14.4 C5.4,12.744 6.7428,11.4 8.4,11.4 Z"
                  id="Combined-Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Facebook() {
  return (
    <svg
      width="10px"
      height="18px"
      viewBox="0 0 10 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Facebook</title>
      <g
        id="Ver2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="UnterbergDuathlon_2"
          transform="translate(-1355.000000, -481.000000)"
          fill="#000"
          fillRule="nonzero"
        >
          <g id="Group-8" transform="translate(1336.000000, 422.000000)">
            <g id="Group-38" transform="translate(0.000000, 44.000000)">
              <g id="facebook-f" transform="translate(19.000000, 15.000000)">
                <path
                  d="M9.00878906,10.125 L9.50871094,6.86742187 L6.38296875,6.86742187 L6.38296875,4.75347656 C6.38296875,3.86226563 6.81960938,2.99355469 8.21953125,2.99355469 L9.64054688,2.99355469 L9.64054688,0.220078125 C9.64054688,0.220078125 8.35101563,0 7.11808594,0 C4.54394531,0 2.86136719,1.56023438 2.86136719,4.3846875 L2.86136719,6.86742187 L0,6.86742187 L0,10.125 L2.86136719,10.125 L2.86136719,18 L6.38296875,18 L6.38296875,10.125 L9.00878906,10.125 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function Instagram() {
  return (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Instagram</title>
      <g
        id="Ver2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="UnterbergDuathlon_2"
          transform="translate(-1471.000000, -481.000000)"
          fill="#000"
          fillRule="nonzero"
        >
          <g id="Group-8" transform="translate(1336.000000, 422.000000)">
            <g id="Group-38" transform="translate(0.000000, 44.000000)">
              <g
                id="Group-15-Copy-3"
                transform="translate(120.000000, 0.000000)"
              >
                <g id="instagram" transform="translate(15.000000, 15.000000)">
                  <path
                    d="M9.00401651,4.38502733 C6.44951467,4.38502733 4.38904385,6.44549816 4.38904385,9 C4.38904385,11.5545018 6.44951467,13.6149727 9.00401651,13.6149727 C11.5585184,13.6149727 13.6189892,11.5545018 13.6189892,9 C13.6189892,6.44549816 11.5585184,4.38502733 9.00401651,4.38502733 Z M9.00401651,12.0003347 C7.35322995,12.0003347 6.0036818,10.6548031 6.0036818,9 C6.0036818,7.34519692 7.34921343,5.99966529 9.00401651,5.99966529 C10.6588196,5.99966529 12.0043512,7.34519692 12.0043512,9 C12.0043512,10.6548031 10.6548031,12.0003347 9.00401651,12.0003347 L9.00401651,12.0003347 Z M14.8841906,4.19625126 C14.8841906,4.79471159 14.4022091,5.27267656 13.8077653,5.27267656 C13.2093049,5.27267656 12.73134,4.79069508 12.73134,4.19625126 C12.73134,3.60180743 13.2133214,3.11982595 13.8077653,3.11982595 C14.4022091,3.11982595 14.8841906,3.60180743 14.8841906,4.19625126 Z M17.9407564,5.28874261 C17.8724757,3.84681468 17.5431217,2.56956376 16.486779,1.51723753 C15.4344528,0.464911302 14.1572018,0.135557291 12.7152739,0.0632600692 C11.2291643,-0.0210866897 6.77485217,-0.0210866897 5.28874261,0.0632600692 C3.85083119,0.131540779 2.57358027,0.46089479 1.51723753,1.51322102 C0.46089479,2.56554725 0.135557291,3.84279817 0.0632600692,5.2847261 C-0.0210866897,6.77083566 -0.0210866897,11.2251478 0.0632600692,12.7112574 C0.131540779,14.1531853 0.46089479,15.4304362 1.51723753,16.4827625 C2.57358027,17.5350887 3.84681468,17.8644427 5.28874261,17.9367399 C6.77485217,18.0210867 11.2291643,18.0210867 12.7152739,17.9367399 C14.1572018,17.8684592 15.4344528,17.5391052 16.486779,16.4827625 C17.5391052,15.4304362 17.8684592,14.1531853 17.9407564,12.7112574 C18.0251032,11.2251478 18.0251032,6.77485217 17.9407564,5.28874261 Z M16.0208636,14.3058128 C15.7075756,15.0930492 15.1010822,15.6995426 14.3098293,16.016847 C13.1249582,16.486779 10.3133995,16.3783331 9.00401651,16.3783331 C7.69463349,16.3783331 4.87905835,16.4827625 3.69820373,16.016847 C2.91096731,15.7035591 2.30447395,15.0970657 1.98716947,14.3058128 C1.51723753,13.1209416 1.62568336,10.309383 1.62568336,9 C1.62568336,7.69061698 1.52125404,4.87504184 1.98716947,3.69418721 C2.30045744,2.9069508 2.9069508,2.30045744 3.69820373,1.98315296 C4.88307486,1.51322102 7.69463349,1.62166685 9.00401651,1.62166685 C10.3133995,1.62166685 13.1289747,1.51723753 14.3098293,1.98315296 C15.0970657,2.29644092 15.7035591,2.90293429 16.0208636,3.69418721 C16.4907955,4.87905835 16.3823497,7.69061698 16.3823497,9 C16.3823497,10.309383 16.4907955,13.1249582 16.0208636,14.3058128 Z"
                    id="Shape"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
